module.exports = __webpack_public_path__ + "static/bg-nature-2-cf3de742e93265cb5fd1460d345dcfca.jpg";